import {useRef} from 'react';
import classNames from 'classnames';
import {useGridListItem} from '@react-aria/gridlist';

import {mergeProps} from '@react-aria/utils';
import {useFocusRing} from '@react-aria/focus';
import {useHover} from '@react-aria/interactions';

import type {Props} from './types';
import {CopyBtn} from './copy-btn';
import styles from './styles.module.css';

export function Item(props: Props) {
    const {item, state, rawItem} = props;
    const ref = useRef<HTMLLIElement>(null);

    const {rowProps, gridCellProps, isDisabled, hasAction} = useGridListItem({node: item}, state, ref);
    const {focusProps, isFocusVisible} = useFocusRing();
    const {hoverProps, isHovered} = useHover({
        isDisabled,
    });

    const copyBtnCanBeShown = isHovered || (isFocusVisible && !rawItem?.onPress);

    return (
        <li
            ref={ref}
            className={classNames(
                styles.layout,
                (isFocusVisible || isHovered) && styles.hovered,
                hasAction && styles.interactive,
            )}
            {...mergeProps(rowProps, focusProps, gridCellProps, hoverProps)}
        >
            {item.rendered}
            {copyBtnCanBeShown && Boolean(rawItem?.clipboardData) && <CopyBtn value={rawItem.clipboardData || ''} />}
        </li>
    );
}
